export default __webpack_public_path__ + "static/404-image-64456bf6cf2d8ee48cacf04da457ce02.png";